import React from 'react';
import { useParams } from 'react-router-dom';

const ParcelCertificateView = ({ parcelCertificates }) => {
  const ids = useParams().id;
  const parcelCert = parcelCertificates.find((item) => item.id === ids);

  console.log(parcelCert);

  if (!parcelCert) {
    return (
      <div className="formParcelCertificate">
        Pas de formulaire trouvé
      </div>
    );
  }

  return (
    <div className="scan">
      <div className="scan__container container">
        <div className="scan__header">
          <h2 className="scan__title">Authentification des documents</h2>
          <div className="scan__sub__title">Résultat du scan</div>
        </div>
        <div className="scan__banner">
          <div className="scan__check">
            <svg
              className="scan__check__icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="red"
            >
              <path d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"></path>
            </svg>
            <div className="scan__banner__content">Le document scanné a été retrouvé</div>
          </div>
          <div className="scan__cross">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red">
              <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
            </svg>
          </div>
        </div>
        <div className="scan__card">
          <div className="scan__card__header">
            <span>DOCUMENT</span>
          </div>
          <div className="scan__card__body">
            <div className="scan__card__body__qrcode">
              {parcelCert.qrCodeLine && (
                <img
                  src={parcelCert.qrCodeLine}
                  alt="QR Code"
                  className="scan__card__body__qrcode__img"
                />
              )}
              <div className="scan__card__body__qrcode__list">
                <div className="scan__card__body__qrcode__item blue">
                  P.No: {parcelCert.parcelNumPage}
                </div>{' '}
                /
                <div className="scan__card__body__qrcode__item blue">
                  H.No: {parcelCert.parcelNumTimbre}
                </div>
              </div>
            </div>
            <div className="scan__card__body__details">
              <div className="scan__card__body__details__city">
                Ville de <span className="blue">Kinshasa</span>
              </div>
              <div className="scan__card__body__details__commune">
                Commune de <span className="blue">{parcelCert.parcelCommune}</span>
              </div>
              <div className="scan__card__body__details__service">
                <span className="blue">Service de la Population</span>
              </div>
            </div>
            <div className="scan__card__body__views">
              <h3 className="scan__card__body__views__title">
                ATTESTATION DE CONFIRMATION PARCELLAIRE N° {parcelCert.parcelNumDossier}
              </h3>
              <div className="scan__card__body__views__contents">
                <div className="scan__card__body__views__content">
                  Je soussigné, <span className="blue">{parcelCert.parcelNameOfficer}</span>, Chef du
                  quartier <span className="blue">{parcelCert.parcelNameQuartier}</span>, atteste et
                  confirme par la présente que la parcelle sise Avenue{' '}
                  <span className="blue">{parcelCert.parcelAvenueOwner}</span> N°{' '}
                  <span className="blue">{parcelCert.parcelNumAvenueOwner}</span>, Quartier{' '}
                  <span className="blue">{parcelCert.parcelQuartierOwner}</span> dans la Commune de{' '}
                  <span className="blue">{parcelCert.parcelCommune}</span>, appartient à
                  Monsieur/Madame/Mademoiselle{' '}
                  <span className="blue">{parcelCert.parcelNamesOwner}</span>, né(e) à{' '}
                  <span className="blue">{parcelCert.parcelCityBirthOwner}</span> le{' '}
                  <span className="blue">{parcelCert.parcelDateBirthOwner}</span>, de profession{' '}
                  <span className="blue">{parcelCert.parcelProfessionOwner}</span>,
                  <br />
                  suivant les documents en sa possession, notamment :
                  <br />
                  1. Acte de vente gré à gré du{' '}
                  <span className="blue">{parcelCert.parcelDateMadeIn}</span>,
                  <br />
                  2. Photocopie de la fiche parcellaire & de l'attestation de confirmation n°{' '}
                  <span className="blue">{parcelCert.parcelAttestationNum}</span> du{' '}
                  <span className="blue">{parcelCert.parcelAttestationDate}</span> du vendeur, de la
                  fiche parcellaire du 1er occupant en sa possession,
                  <br />
                  3. Ainsi que les renseignements issus du fichier du bureau du quartier.
                </div>
                <div className="scan__card__body__views__content blue">
                  En foi de quoi, la présente est établie pour servir et faire valoir ce que de droit.
                </div>
              </div>
              <div className="scan__card__body__views__dates">
                <div className="scan__card__body__views__dates__realisation">
                  Fait à <span className="blue">{parcelCert.parcelCityMadeIn}</span>, le{' '}
                  <span className="blue">{parcelCert.parcelDateMadeIn}</span>
                </div>
                <div className="scan__card__body__views__dates__sign">
                  Le Chef du Quartier
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="scan__footer">
        © 2020-2024 <a href="https://www.afriquedigitalsk.com/">Afrique Digitale</a> - Système de
        gestion des communes
      </div>
    </div>
  );
};

export default ParcelCertificateView;